import { clamp } from '@styles/utils/conversion.style'
import { colors } from '@styles/vars/colors.style'
import { mq } from '@styles/vars/media-queries.style'
import {
  getCustomTextStyle,
  textStylesConfig,
} from '@styles/vars/textStyles.style'
import styled from 'styled-components'

export const PartnersMain = styled.section`
  background-color: ${props => props.background};
  color: ${props => props.color};
`

export const PartnersWrapper = styled.div``

export const PartnersHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const PartnersFooter = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  ${clamp('margin-top', 30, 50)}
`

export const PartnersTitle = styled.h2`
  ${getCustomTextStyle(textStylesConfig.heading4Sans, textStylesConfig.caption)}
`

export const PartnersNav = styled.ul`
  display: flex;
  list-style: none;

  ${mq.tabletPMax} {
    display: none;
  }
  button {
    > div {
      background: ${props => props.backgroundColor} !important;
      color: ${props => props.fontColor} !important;
      border: 1px solid ${props => props.fontColor} !important;
      border-radius: 7rem;
    }
    &:not(:disabled):hover > div {
      background: ${props => props.fontColor} !important;
      color: ${props => props.backgroundColor} !important;
      border: 1px solid ${props => props.fontColor}  !important;
    }

    &:disabled > div {
      opacity: 0.5;
    }
  }
`

export const PartnersNavItem = styled.li`
  & + & {
    margin-left: 1rem;
  }
`

export const PartnersCarousel = styled.div`
  display: flex;
  width: fit-content;
  ${clamp('margin-top', 30, 90)}
  transform: ${props => props.centered ? 'unset !important' : ''};
  justify-content: ${props => props.centered ? 'center' : ''};
  min-width: ${props => props.centered ? '100%' : ''};
`

export const PartnersCardWrapper = styled.div`
  a {
    display: flex;
    flex-direction: column;
    position: relative;
  }
  &:not(:first-child) {
    ${clamp('padding-left', 15, 30)}
  }
  &:hover {
    .more, svg {
      ${mq.tabletL} {
        opacity: 1;
        transform: translateX(5px);
      }
    }
  }
`

export const PartnersCard = styled.div`
  ${clamp('width', 140, 270)}
  ${clamp('height', 50, 156)}
  background: ${props => props.hasBackground ? props.isDark ? 'rgba(255,255,255, 0.1)' : '#ededed' : null};
  transition: all 0.25 ease;
  display: flex;
  align-items: center;
  &:hover {
    background: ${props => props.hasBackground ? props.isDark ? 'rgba(255,255,255, 0.3)' : '#e1e1e1' : null};
    
  }
`

export const PartnersCardThumbnail = styled.div`
`

export const PartnersCardContent = styled.div`
  margin-top: 20px;
`

export const PartnersRole = styled.div`
  font-size: 14px;
`

export const PartnersCardLink = styled.span`
  position: absolute;
  right: 5px;
  top: 5px;
  ${mq.tabletL} {
    right: 15px;
    top: 15px;
  }
  display: flex;
  text-decoration: none;
  font-size: 13px;
  z-index: 1;
  .more {
    opacity: 0;
    transition: all 0.25s ease;
  }

  svg {
    transition: all 0.25s ease;
    margin-left: 10px;
    width: 10px;
  }

`
